import NavigableValidator, {INavigableValidatorOptions} from "~/models/navigableValidators/navigableValidator";
import {ErrorType} from "~/enums/ErrorType";
import {INavigableValidatableModel} from "~/interfaces/navigableValidationInterfaces";

export default class LengthValidator<T> extends NavigableValidator<T> {
  defaultMessage = 'Invalid value';
  defaultType = ErrorType.invalidValue;

  min: number;
  max: number;

  constructor(min: number, max: number, options: Partial<INavigableValidatorOptions<T>>) {
    super(options);
    this.min = min;
    this.max = max;
  }

  _validate(model: INavigableValidatableModel<T>): void {
    const length = model[this.field]?.length ?? 0;
    if (length < this.options.min || length > this.options.max) {
      this.errors.push(this.buildValidationError(model, this.field));
    }
  }
}